import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import arrowRight from "../icons/arrow-right.svg";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Link } from "react-router-dom";
import SubText from "./SubText";
import Title from "./Title";
import SimpleText from "./SimpleText";

const AvoidPlans = ({ content }) => {
  const theme = useTheme();
  const isPad = useMediaQuery("(max-width:900px)");

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        marginBottom: "10%",
        padding: "3%",
      }}
    >
      <SubText text={content?.details?.title} />

      <SimpleText
        text={content?.details?.subtitle}
        style={{
          fontSize: { xs: "4.5vw", sm: "4.5vw", md: "3.5vw", lg: "20px" },
          marginTop: "3%",
          color: "#2f2f2f",
          padding: { lg: "0 52px" },
          textAlign: "center",
        }}
      />
      <Box
        sx={{
          marginTop: "3%",
          display: "flex",
          alignItems: "center",
          //   padding: "1%",
          flexDirection: {
            xs: "column",
            sm: "column",
            md: "column",
            lg: "row",
          },
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            //   padding: "1%",
            flexDirection: "row",
            width: "100%",
            justifyContent: "flex-end",
          }}
        >
          <Box
            onClick={() => {
              window.location.href = `/${
                content && Object.values(content?.details)[2]
              }?zipcode=77005&term=12`;
            }}
            sx={{
              boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.15)",
              cursor: "pointer",
              borderRadius: { xs: "5vw", sm: "5vw", md: "3vw", lg: "20px" },
              position: "relative",
              padding: {
                xs: "5%",
                sm: "5%",
                md: "5%",
                lg: "30px",
              },
              width: { xs: "50%", sm: "50%", md: "50%", lg: "250px" },
              height: { xs: "16vw", sm: "16vw", md: "8vw", lg: "7vw" },
              margin: "1.5%",
            }}
          >
            <Typography
              sx={{
                marginBottom: "2%",
                marginTop: "2%",
              }}
            >
              <Typography
                sx={{
                  fontSize: {
                    xs: "13px",
                    md: "3vw",
                    lg: "30px",
                  },
                  marginBottom: "5%",
                  color: theme.palette.primary.main,
                }}
                variant="body2"
              >
                <b>{content && Object.keys(content?.details)[2]}</b>
              </Typography>
            </Typography>

            <img
              style={{ position: "absolute", bottom: "18%", right: "10%" }}
              width="35px"
              src={arrowRight}
            />
          </Box>
          <Box
            onClick={() => {
              window.location.href = `/${
                content && Object.values(content?.details)[3]
              }?zipcode=77005&term=12`;
            }}
            sx={{
              boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.15)",
              cursor: "pointer",
              borderRadius: { xs: "5vw", sm: "5vw", md: "3vw", lg: "20px" },
              position: "relative",
              padding: {
                xs: "5%",
                sm: "5%",
                md: "5%",
                lg: "30px",
              },
              width: { xs: "50%", sm: "50%", md: "50%", lg: "250px" },
              height: { xs: "16vw", sm: "16vw", md: "8vw", lg: "7vw" },
              margin: "1.5%",
            }}
          >
            <Typography
              sx={{
                marginBottom: "2%",
                marginTop: "2%",
              }}
            >
              <Typography
                sx={{
                  fontSize: {
                    xs: "13px",
                    md: "3vw",
                    lg: "30px",
                  },
                  marginBottom: "5%",
                  color: theme.palette.primary.main,
                }}
                variant="body2"
              >
                <b>{content && Object.keys(content?.details)[3]}</b>
              </Typography>
            </Typography>

            <img
              style={{ position: "absolute", bottom: "18%", right: "10%" }}
              width="35px"
              src={arrowRight}
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            //   padding: "1%",
            flexDirection: "row",
            width: "100%",
            justifyContent: "flex-start",
          }}
        >
          <Box
            onClick={() => {
              window.location.href = `/${
                content && Object.values(content?.details)[4]
              }?zipcode=77005&term=12`;
            }}
            sx={{
              boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.15)",
              cursor: "pointer",
              borderRadius: { xs: "5vw", sm: "5vw", md: "3vw", lg: "20px" },
              position: "relative",
              padding: {
                xs: "5%",
                sm: "5%",
                md: "5%",
                lg: "30px",
              },
              width: { xs: "50%", sm: "50%", md: "50%", lg: "250px" },
              height: { xs: "16vw", sm: "16vw", md: "8vw", lg: "7vw" },
              margin: "1.5%",
            }}
          >
            <Typography
              sx={{
                marginBottom: "2%",
                marginTop: "2%",
              }}
            >
              <Typography
                sx={{
                  fontSize: {
                    xs: "13px",
                    md: "3vw",
                    lg: "30px",
                  },
                  marginBottom: "5%",
                  color: theme.palette.primary.main,
                }}
                variant="body2"
              >
                <b>{content && Object.keys(content?.details)[4]}</b>
              </Typography>
            </Typography>

            <img
              style={{ position: "absolute", bottom: "18%", right: "10%" }}
              width="35px"
              src={arrowRight}
            />
          </Box>
          <Box
            onClick={() => {
              window.location.href = `/${
                content && Object.values(content?.details)[5]
              }?zipcode=77005&term=12`;
            }}
            sx={{
              boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.15)",
              cursor: "pointer",
              borderRadius: { xs: "5vw", sm: "5vw", md: "3vw", lg: "20px" },
              position: "relative",
              padding: {
                xs: "5%",
                sm: "5%",
                md: "5%",
                lg: "30px",
              },
              width: { xs: "50%", sm: "50%", md: "50%", lg: "250px" },
              height: { xs: "16vw", sm: "16vw", md: "8vw", lg: "7vw" },
              margin: "1.5%",
            }}
          >
            <Typography
              sx={{
                marginBottom: "2%",
                marginTop: "2%",
              }}
            >
              <Typography
                sx={{
                  fontSize: {
                    xs: "13px",
                    md: "3vw",
                    lg: "30px",
                  },
                  marginBottom: "5%",
                  color: theme.palette.primary.main,
                }}
                variant="body2"
              >
                <b>{content && Object.keys(content?.details)[5]}</b>
              </Typography>
            </Typography>

            <img
              style={{ position: "absolute", bottom: "18%", right: "10%" }}
              width="35px"
              src={arrowRight}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AvoidPlans;
